<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            编辑标签
          </div>
          <el-form
            class="good-form base-info-form"
            label-width="80px"
            label-position="right"
          >
            <el-form-item label="产品优点" prop="profit" class="form-item">
              <div class="category">
                <div
                  class="item"
                  v-for="(item, index) in advantageSelected"
                  :key="item.id"
                >
                  {{ item.labelName }}
                  <div
                    class="iconfont icon-shanchu"
                    @click="deleteAdvantage(index)"
                  ></div>
                </div>
              </div>
              <div
                class="add-category"
                @click="handleAddModal('advantage', '产品优点')"
              >
                + 添加产品优点
              </div>
            </el-form-item>
            <el-form-item
              label="营养分析（常规）"
              prop="profit"
              class="form-item"
            >
              <div class="category">
                <div
                  class="item"
                  v-for="(item, index) in regularSelected"
                  :key="item.id"
                >
                  {{ item.labelName }}
                  <div
                    class="iconfont icon-shanchu"
                    @click="deleteRegular(index)"
                  ></div>
                </div>
              </div>
              <div
                class="add-category"
                @click="handleAddModal('regular', '常规营养')"
              >
                + 添加常规营养
              </div>
            </el-form-item>
            <el-form-item
              label="营养分析（强化）"
              prop="profit"
              class="form-item"
            >
              <div class="category">
                <div
                  class="item"
                  v-for="(item, index) in intensifySelected"
                  :key="item.id"
                >
                  {{ item.labelName }}
                  <div
                    class="iconfont icon-shanchu"
                    @click="deleteIntensify(index)"
                  ></div>
                </div>
              </div>
              <div
                class="add-category"
                @click="handleAddModal('intensify', '强化营养')"
              >
                + 添加强化营养
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
    <el-dialog
      :title="'添加/关联' + labelTitle"
      width="480px"
      :visible.sync="addVisible"
    >
      <div :key="timeStamp">
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="labelTable"
          height="500px"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="labelName"
            align="center"
            label="选项名称"
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: { Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: '编辑标签'
      },
      id: null,
      baseInfo: {
        name: '',
        brand: null,
        series: null,
        masterPic: '',
        price: null,
        status: null,

        milkVersion: null,  // 奶粉版本
        milkSource: null, // 奶源地
        milkOrigin: null, // 产地
        milkCategory: null, // 类别
        milkSpecification: null,  //规格
        milkRecommendedAge: null, //适用年龄

        ingredientList: '', // 配料表
        milkReview: '', // 奶粉点评
        sourceReview: '',// 奶源点评
        materialReview: '',// 原料点评
        milkStage: '', //段位

        manufacturer: '', // 厂家
        regNo: '', // 注册号
        serviceProvider: '', // 运营商

        ingredientUnit: '',

        advantage: '',
        nutritionalAnalysisNormal: '',
        nutritionalAnalysisFortify: '',

        ingredientTable: [],
        customFields: [],
        alias: [],
        summary: ''
      },
      advantage: [],
      advantageSelected: [],
      regular: [],
      regularSelected: [],
      intensify: [],
      intensifySelected: [],
      multipleSelection: [],
      list: [],
      addVisible: false,
      timeStamp: +new Date(),
      labelTitle: '',
      name: ''
    };
  },
  computed: {},
  async mounted() {
    await this.getLabelItem();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取产品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getGoodInfo, { id }).then(
        (res) => {
          this.loading--;
          let baseInfo = { ...this.baseInfo };
          for (let key in baseInfo) {
            baseInfo[key] = res[key];
          }
          this.baseInfo = { ...baseInfo };
          this.id = res.id;
          this.advantage.forEach(item => {
            let arr = res.advantage.split(',');
            if(arr.includes(item.id + '')){
              this.advantageSelected.push(item);
            }
          });
          this.regular.forEach(item => {
            let arr = res.nutritionalAnalysisNormal.split(',');
            if(arr.includes(item.id + '')){
              this.regularSelected.push(item);
            }
          });
          this.intensify.forEach(item => {
            let arr = res.nutritionalAnalysisFortify.split(',');
            if(arr.includes(item.id + '')){
              this.intensifySelected.push(item);
            }
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getLabelItem(){
      // this.getLabelItemByName('advantage');
      // this.getLabelItemByName('regular');
      // this.getLabelItemByName('intensify');
      return Promise.all([
        this.getLabelItemByName('advantage'),
        this.getLabelItemByName('regular'),
        this.getLabelItemByName('intensify'),
      ]);
    },
    getLabelItemByName(dataName){
      this.loading++;
      return this.httpGet(this.$root.getLabelItem, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // handleCategoryModal(){
    //   this.multipleSelection = this.categorySelected;
    //   this.timeStamp = +new Date();
    //   this.categoryVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.labelTable.clearSelection();
    //     this.multipleSelection.forEach(item => {
    //       this.$refs.labelTable.toggleRowSelection(item, true);
    //     });
    //   })
    // },
    handleAddModal(name, title){
      this.labelTitle = title;
      this.name = name;
      this.list = this[name];
      this.timeStamp = +new Date();

      switch (this.name) {
        case 'advantage':
          this.multipleSelection = this.advantageSelected;
          break;
        case 'regular':
        this.multipleSelection = this.regularSelected;
          break;
        case 'intensify':
        this.multipleSelection = this.intensifySelected;
          break;
      };
      this.addVisible = true;
        this.$nextTick(() => {
        this.$refs.labelTable.clearSelection();
        this.multipleSelection.forEach(item => {
          this.$refs.labelTable.toggleRowSelection(item, true);
        });
      })
    },
    handleAdd(){
      switch (this.name) {
        case 'advantage':
          this.advantageSelected = this.multipleSelection;
          break;
        case 'regular':
          this.regularSelected = this.multipleSelection;
          break;
        case 'intensify':
          this.intensifySelected = this.multipleSelection;
          break;
      }
      this.addVisible = false;
    },
    deleteAdvantage(index){
      this.advantageSelected.splice(index, 1);
    },
    deleteRegular(index){
      this.regularSelected.splice(index, 1);
    },
    deleteIntensify(index){
      this.intensifySelected.splice(index, 1);
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'goodsManage' });
    },
    handleConfirm(){
      this.loading++;
      this.httpPut(this.$root.updateGood, {
        id: this.id,
        ...this.baseInfo,
        advantage: this.advantageSelected.map(item => item.id).join(','),
        nutritionalAnalysisNormal: this.regularSelected.map(item => item.id).join(','),
        nutritionalAnalysisFortify: this.intensifySelected.map(item => item.id).join(',')
      }).then(
        (res) => {
          this.$message({
            message: '产品标签修改成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'goodsManage'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 20px 24px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .category{
          width: 600px;
          min-height: 120px;
          border-radius: 5px;
          border: 1px solid #E8E8E8;
          padding: 6px 10px;
          box-sizing: border-box;
          flex-x(flex-start, flex-start);
          flex-wrap: wrap;
          .item{
            height: 24px;
            min-width: 60px;
            padding:0 12px;
            border-radius: 2px;
            background: #EBEBEB;
            word(12px, #333);
            flex-x(center);
            margin-right: 8px;
            margin-bottom: 8px;
            position: relative;
            div{
              line-height: 16px;
              position: absolute;
              right: -6px;
              top: -6px;
              cursor: pointer;
            }
          }
        }

        .add-category{
          // width: 80px;
          cursor: pointer;
          color: #5283FF;
          flex-x(flex-start);
          flex-shrink: 0;
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
